import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ListChecks } from "lucide-react";
import { web } from "../../lib/api";
import { useApi } from "../../hooks/useApi";

const Row = ({ i }) => (
  <li data-testid={`quiz-progress-item-${i.play_id}`} className="flex items-center justify-between gap-3 py-2 text-sm">
    <span className="flex min-w-0 items-center gap-2">
      {i.passed ? <CheckCircle2 className="h-4 w-4 shrink-0 text-[#39FF14]" /> : <Circle className="h-4 w-4 shrink-0 text-slate-500" />}
      <span className="truncate text-white">{i.title}</span>
      <span className="hidden font-mono-gd text-[10px] uppercase text-slate-400 sm:inline">{i.category}</span>
    </span>
    <span className={`shrink-0 font-mono-gd text-xs uppercase ${i.passed ? "text-[#39FF14]" : i.best == null ? "text-slate-400" : "text-amber-300"}`}>
      {i.passed ? `Passed · ${i.best}%` : i.best == null ? "Not taken" : `Best ${i.best}% · needs ${i.pass_pct}%`}
    </span>
  </li>
);

/** Playbook readiness on a player profile: quizzes passed vs. quizzes on plays the player can see. */
export const QuizProgress = ({ tid, pid }) => {
  const { data, error } = useApi(tid && pid && `/teams/${tid}/players/${pid}/quiz-progress`, web);
  if (error || !data) return null;
  const total = data.total ?? 0;
  const passed = data.passed ?? 0;
  const items = Array.isArray(data.items) ? data.items : [];
  const pct = total ? Math.round((100 * passed) / total) : 0;
  return (
    <section data-testid="quiz-progress" className="mb-6 rounded-2xl border border-[#1E293B] bg-[#0F172A] p-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <ListChecks className="h-5 w-5 text-[#39FF14]" />
          <h2 className="font-display text-xl font-bold uppercase text-white">Playbook progress</h2>
          {total > 0 && (
            <span data-testid="quiz-progress-status" className={`rounded-full px-2.5 py-1 font-mono-gd text-[10px] font-bold uppercase tracking-wider ${data.game_ready ? "bg-[#39FF14] text-[#0A0E1A]" : "bg-amber-300/15 text-amber-300"}`}>
              {data.game_ready ? "Game-ready" : `${total - passed} to go`}
            </span>
          )}
        </div>
        <p data-testid="quiz-progress-count" className="font-display text-2xl font-black text-white">{passed}<span className="text-slate-400">/{total}</span> <span className="font-mono-gd text-xs font-normal uppercase text-slate-400">quizzes passed</span></p>
      </div>
      {total === 0 ? (
        <p className="mt-3 text-sm text-slate-400">No play quizzes yet. <Link to="/coach/playbook" className="text-[#39FF14] hover:underline">Open the playbook</Link></p>
      ) : (
        <>
          <div className="mt-4 h-2 overflow-hidden rounded-full bg-[#162032]"><div data-testid="quiz-progress-bar" className="h-full bg-[#39FF14] transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
          <ul className="mt-3 divide-y divide-[#1E293B]">{items.map((i) => <Row key={i.play_id} i={i} />)}</ul>
        </>
      )}
    </section>
  );
};
